const storageKey = (slug: string) => `parcours_progress_${slug}`;

export function getProgress(slug: string): string[] {
  try {
    const raw = localStorage.getItem(storageKey(slug));
    if (!raw) return [];
    return JSON.parse(raw) as string[];
  } catch {
    return [];
  }
}

export function markStepDone(slug: string, stepId: string): void {
  try {
    const current = getProgress(slug);
    if (!current.includes(stepId)) {
      localStorage.setItem(storageKey(slug), JSON.stringify([...current, stepId]));
    }
  } catch {
    // localStorage indisponible — progression silencieusement ignorée
  }
}

export function clearProgress(slug: string): void {
  try {
    localStorage.removeItem(storageKey(slug));
  } catch {
    // silent
  }
}
